module.exports = __webpack_public_path__ + "img/pleisure_bodyimage01.f9bc6189.jpg";